<div class="container">
  <div class="row">
    <div class="col-12 wrapper">
      <div class="h-100 d-flex flex-column flex-sm-row justify-content-center align-items-center">
        <div class="banner-carousel h-100">
          <app-carousel-slider [banners]="banners"></app-carousel-slider>
        </div>
      </div>
    </div>
  </div>
</div>
